import axios from 'axios';
import { getApiBaseUrl } from './api';
import { getAuthAccessToken } from './demoPreviewStorage';

/** Base URL for customization microservice (same-origin `/api/customization` behind frontend nginx). */
export function getCustomizationBaseUrl() {
  const apiBase = getApiBaseUrl().replace(/\/+$/, '');
  return `${apiBase}/customization`;
}

const customizationApi = axios.create({
  headers: { 'Content-Type': 'application/json' }
});

customizationApi.interceptors.request.use((config) => {
  config.baseURL = getCustomizationBaseUrl();
  const token = getAuthAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

customizationApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default customizationApi;
